"use client";
import React, { useEffect, useState } from "react";
import { Form, Col } from "react-bootstrap";
import common from "../../../utils/common";
import type { ModalInputProp } from "../../../class/frontend.schema";

export default function DateInput({
  placeholder,
  value,
  setValueFunc,
  invalid,
  invalidMsg,
}: ModalInputProp) {
  const [textVal, setTextVal] = useState(
    common.getDateTimeLocalValue(new Date()),
  );
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;
    setTextVal(val);
    if (!common.stringIsNullOrEmpty(val)) {
      setValueFunc(event.target.value);
    }
  };

  useEffect(() => {
    if (!value) {
      return;
    }
    setTextVal(value as string);
  }, [value]);

  return (
    <Form.Group as={Col} md="6" controlId={`eventModal.${placeholder}`}>
      <Form.Label>{placeholder}</Form.Label>
      <Form.Control
        value={textVal}
        type="datetime-local"
        placeholder={placeholder}
        onChange={onChange}
        isInvalid={invalid}
      />
      <Form.Control.Feedback type="invalid">{invalidMsg}</Form.Control.Feedback>
    </Form.Group>
  );
}
